import { css } from 'lit';

// language=CSS
export const transparentButton =
css`
    .transparent-button {
        height: 2.75rem;
        background-color: transparent !important;
        color: rgb(var(--sp-color-a));
        box-shadow: unset !important;
    }

    .transparent-button[disabled] {
        opacity: 0.4;
    }
`;
